export enum EstadoCanjesEnum { REQUESTED, AUTHORIZED, DELIVERED, RECOVERING, REFUNDED, ERROR }

const idsEstadoCanjes = new Map<EstadoCanjesEnum, string>();
idsEstadoCanjes.set(EstadoCanjesEnum.REQUESTED, "REQUESTED");
idsEstadoCanjes.set(EstadoCanjesEnum.AUTHORIZED, "AUTHORIZED");
idsEstadoCanjes.set(EstadoCanjesEnum.DELIVERED, "DELIVERED");
idsEstadoCanjes.set(EstadoCanjesEnum.RECOVERING, "RECOVERING");
idsEstadoCanjes.set(EstadoCanjesEnum.REFUNDED, "REFUNDED");
idsEstadoCanjes.set(EstadoCanjesEnum.ERROR, "ERROR");

const nombresEstadoCanjes = new Map<EstadoCanjesEnum, string>();
nombresEstadoCanjes.set(EstadoCanjesEnum.REQUESTED, "Solicitado");
nombresEstadoCanjes.set(EstadoCanjesEnum.AUTHORIZED, "Autorizado");
nombresEstadoCanjes.set(EstadoCanjesEnum.DELIVERED, "Entregado");
nombresEstadoCanjes.set(EstadoCanjesEnum.RECOVERING, "Recuperando");
nombresEstadoCanjes.set(EstadoCanjesEnum.REFUNDED, "Reembolsado");
nombresEstadoCanjes.set(EstadoCanjesEnum.ERROR, "Error");

export const obtenerIdEstadoCanje: (estado: EstadoCanjesEnum) => string = estado => idsEstadoCanjes.get(estado) ?? "";

export const obtenerNombresEstadoCanjes: () => Array<[EstadoCanjesEnum, string]> =
    () => Array.from(nombresEstadoCanjes.entries());
